"use client"

import { Button } from "@/components/ui/button"

export function CheckoutButton() {
  return (
    <Button
      size="lg"
      className="uppercase tracking-wide"
      onClick={() => alert("Đây là bản demo — chưa tích hợp thanh toán.")}
    >
      Thanh toán
    </Button>
  )
}
